import { get, post, del, put } from '@api/request';
import { defaultPageSize } from '@constants';

const namespace = 'litigation';

export async function fetchSearchOptions(
  { litigationService },
  authenticationToken,
) {
  const url = `${litigationService}/${namespace}/config/arbitratorsearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchArbitrator(
  { litigationService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  console.log('searchArbitrator');
  let url = `${litigationService}/${namespace}/arbitrator/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  console.log(body);
  return body;
}

export async function lookupArbitrator(
  { litigationService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  console.log('lookupArbitrator');
  let url = `${litigationService}/${namespace}/arbitrator/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  console.log(body);
  return body;
}

export async function fetchFields({ litigationService }, authenticationToken) {
  const url = `${litigationService}/${namespace}/config/arbitratorsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrator(
  { litigationService },
  authenticationToken,
  { arbitratorID },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitratorNotes(
  { litigationService },
  authenticationToken,
  { arbitratorID },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitratorProperties(
  { litigationService },
  authenticationToken,
  { arbitratorID },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}/property`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteArbitratorNote(
  { litigationService },
  authenticationToken,
  { id },
) {
  const url = `${litigationService}/${namespace}/arbitratornote/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateArbitratorNote(
  { litigationService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${litigationService}/${namespace}/arbitratornote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function addArbitratorNote(
  { litigationService },
  authenticationToken,
  { id, data },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${id}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function validateArbitrator(
  { litigationService },
  authenticationToken,
  { arbitratorID, data },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}/casscertification`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateArbitrator(
  { litigationService },
  authenticationToken,
  { arbitratorID, data },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteArbitrator(
  { litigationService },
  authenticationToken,
  { arbitratorID },
) {
  const url = `${litigationService}/${namespace}/arbitrator/${arbitratorID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createArbitrator(
  { litigationService },
  authenticationToken,
  { data },
) {
  const url = `${litigationService}/${namespace}/arbitrators`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}
